export enum PublicTransportType {
    BUS = "bus",
    TRAIN = "train"
}